const CardPayment = () => {

}
export default CardPayment;